var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v("組織資料設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("通知樣板管理")])], 1)], 1)])]), _c('b-card', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('b-card-text', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.templates,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button-group', [_c('b-button', {
          attrs: {
            "title": "編輯",
            "to": {
              name: 'TemplateEdit',
              params: {
                template_id: data.item.id
              }
            }
          }
        }, [_c('BIconPencil')], 1), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "title": "預覽 (TODO)",
            "to": {
              name: 'TemplateShow',
              params: {
                template_id: data.item.id
              }
            }
          }
        }, [_c('BIconEye')], 1)], 1)];
      }
    }])
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": 10,
      "align": "center"
    },
    on: {
      "change": _vm.getTemplates
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }